@for (content of contentInput(); track $index) {
	@if (components) {
		<ndc-dynamic
			[ndcDynamicComponent]="components[content['component']]"
			[ndcDynamicInputs]="content"
		/>
	}
}
